import React from "react";
import { BtsLogo } from "./BtsLogo";
import { Linkedin, Mail, Phone } from "lucide-react";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-black text-white border-t border-white/10"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="inline-block bg-white p-3 border border-black">
              <BtsLogo size={36} />
            </div>
            <p className="mt-5 text-white/70 max-w-sm text-sm">
              Behavioural training programs for organisations, campuses and
              rising professionals — by Ruchika Thakkar Singh.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="overline text-white/50 mb-4">Explore</div>
            <ul className="space-y-2 text-sm">
              {["about", "services", "pricing", "faq", "contact"].map((id) => (
                <li key={id}>
                  <a
                    data-testid={`footer-link-${id}`}
                    href={`#${id}`}
                    className="hover:text-[color:var(--bts-yellow)] transition-colors capitalize"
                  >
                    {id}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline text-white/50 mb-4">Contact</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-3">
                <Mail size={14} />
                <a
                  href="mailto:ruchika.thakkar1@gmail.com"
                  className="hover:text-[color:var(--bts-yellow)] transition-colors"
                  data-testid="footer-email"
                >
                  ruchika.thakkar1@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={14} />
                <a
                  href="tel:+919960164633"
                  className="hover:text-[color:var(--bts-yellow)] transition-colors"
                  data-testid="footer-phone"
                >
                  +91 99601 64633
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Linkedin size={14} />
                <a
                  href="https://www.linkedin.com/in/ruchika-thakkar-singh/"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-[color:var(--bts-yellow)] transition-colors"
                  data-testid="footer-linkedin"
                >
                  ruchika-thakkar-singh
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between text-xs text-white/50 gap-3">
          <span>© {year} Behavioural Training Spectrum. All rights reserved.</span>
          <span>Built with clarity · Yellow means action.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
